<template>
  <div v-if="formats">
    TTS字符替换:
    <div v-for="(fmt, idx) in formats" :key="idx">
      当发送内容为:{{fmt.match}} &nbsp;&nbsp; 将:{{fmt.pattern}} &nbsp;&nbsp; 替换为:{{fmt.replace}}
    </div>
  </div>
</template>

<script>
export default {
  name: "tts_format",
  props: {
    formats: Array
  }
}
</script>